import { Button } from '@mui/material';
import { useAuthContext } from 'src/auth/hooks';
import { ConfirmDialog } from 'src/components/custom-dialog';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function DialogLogout({ open, onClose }: Props) {
  const { logout } = useAuthContext();

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      title="ออกจากระบบ"
      content="คุณต้องการออกจากระบบหรือไม่?"
      action={
        <Button variant="contained" onClick={logout} color="inherit">
          ออกจากระบบ
        </Button>
      }
    />
  );
}
